import React from 'react';
import { Skeleton } from 'antd-mobile';
import './ProductSkeleton.css';

interface ProductSkeletonProps {
  count?: number;
}

const ProductSkeleton: React.FC<ProductSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className="product-skeleton-list">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="product-skeleton-item">
          <div className="skeleton-image">
            <Skeleton animated className="skeleton-image-box" />
          </div>
          <div className="skeleton-info">
            <Skeleton.Title animated />
            <Skeleton.Paragraph lineCount={1} animated />
            <div className="skeleton-price">
              <Skeleton animated style={{ width: '80px', height: '28px' }} />
            </div>
            <Skeleton.Paragraph lineCount={1} animated />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
